module.exports = __webpack_public_path__ + "static/media/slideImgSix@2x.114f4073.png";